import { FC } from 'react';

type Props = {
    className?: string;
};

const QuestionsIcon: FC<Props> = ({ className }) => {
    return (
        <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            stroke="#EAEAEA"
            className={className}
        >
            <path
                d="M10.0013 18.3337C14.6037 18.3337 18.3346 14.6027 18.3346 10.0003C18.3346 5.39795 14.6037 1.66699 10.0013 1.66699C5.39893 1.66699 1.66797 5.39795 1.66797 10.0003C1.66797 14.6027 5.39893 18.3337 10.0013 18.3337Z"
                stroke="inherit"
                strokeWidth="1.25"
                strokeLinecap="square"
                strokeLinejoin="round"
            />
            <path
                d="M10 13.75H10.0075"
                stroke="inherit"
                strokeWidth="1.66667"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M8.33594 7.91667C8.33594 6.99619 9.0821 6.25 10.0026 6.25C10.9231 6.25 11.6693 6.99619 11.6693 7.91667C11.6693 8.24846 11.5724 8.55758 11.4052 8.81733C10.9071 9.59142 10.0026 10.3295 10.0026 11.25"
                stroke="inherit"
                strokeWidth="1.25"
                strokeLinecap="round"
            />
        </svg>
    );
};

export default QuestionsIcon;
